import React, { useEffect, useState, useCallback } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

import { GreyCheckbox } from '../style/customUI';
import SideStyle from '../style/sideStyle';
import Param from '../store/param';
import Control from '../store/control';
import { AddIcon } from './formUtil';
import { toast } from 'react-toastify';
import * as helptext from './helptext';
import * as dataAnalysis from '../dataAnalysis/ak';

const FormBaseShape = () => {
  const SetCameraTop = Control.Get('SetCameraTop');

  const style      = SideStyle();
  const align  = Param.Get('align');
  const baseshape  = Param.Get('baseshape');
  const setParam   = Param.Get('setParam');
  const setControl = Control.Get('setControl');
  const meshLeg = Control.Get('meshLeg');

  const [showAdvance, setShowAdvance] = useState(false);

  useEffect(() => {
    SetCameraTop();
    toast('Ajust the base shape of IT level');
  }, [])

  // this is for the compressin line id update
  useEffect(() => {
    var temp = Math.floor((align.stumpLength+align.stumpLengthAdjust) / align.interval);
    setParam(s => {s.compress.line_no = temp});
    // save meshLeg after alignment.
    const tempMesh = meshLeg.clone();
    tempMesh.geometry = meshLeg.geometry.clone(); // for deepcopy
    setControl(s => {s.meshLegAligned = tempMesh});
  }, [])

  const handleValue = (e) => {
    setParam(s => {s.baseshape[e.target.name] = Number(e.target.value)});
  };

  return (
    <div className={style.outside}>
      {/* Basic Setting */}
      <Grid container spacing={1} alignItems='center' justifyContent='center'>
        <Grid container direction='column' justifyContent ='flex-start' alignItems='center'>
          <Grid item xs={12} className={style.subcategory}>Whole Setting</Grid>
        </Grid>

        <TextField
          id='filled-number'
          key={'apDiameter' + baseshape.apDiameter} // to force upate DOM elements. value element doesnt work fine. https://mseeeen.msen.jp/react-update-input-defaultvalue/
          name='apDiameter'
          label='AP diameter(tentative value)'
          type='number'
          defaultValue={baseshape.apDiameter}
          fullWidth
          onBlur={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          onMouseOver={() => setControl(s => {s.explanationText = helptext.apDiameter; s.explanationImg = './static/ak/img/apDiameter.png'})}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start">mm</InputAdornment>,
            // endAdornment:
            //   <AddIcon 
            //     unit='mm' 
            //     helptext={helptext.apDiameter}
            //     title='AP diameter'
            //     imgSrc='./static/ak/img/apDiameter.png'
            //     data={dataAnalysis.apDiameter}
            //     name='apDiameter'
            //     onBarClick={handleValue}
            //   />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:1, 
            max:500,
            step:1
          }}
        />

        <TextField
          id='filled-number'
          key={'ischiumCircumference' + baseshape.ischiumCircumference}
          name='ischiumCircumference'
          label='Ischium circumference(tentative value)'
          type='number'
          defaultValue={baseshape.ischiumCircumference}
          fullWidth
          onBlur={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          onMouseOver={() => setControl(s => {s.explanationText = helptext.ischiumCircumference})}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start">mm</InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='mm' 
            //   helptext={helptext.ischiumCircumference}
            //   title='Ischium circumference'
            //   imgSrc='./static/ak/img/ischiumCircumference.png'
            //   data={dataAnalysis.ischiumCircumference}
            //   name='ischiumCircumference'
            //   onBarClick={handleValue}
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:1, 
            max:1000,
            step:1
          }}
        />

        <TextField
          id='filled-number'
          key={'compression' + baseshape.compression}
          name='compression'
          label='Compression[%]'
          type='number'
          defaultValue={baseshape.compression}
          fullWidth
          onBlur={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          onMouseOver={() => setControl(s => {s.explanationText = helptext.compression})}
          onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
          InputProps={{
            endAdornment: <InputAdornment position="start">%</InputAdornment>,
            // endAdornment: 
            // <AddIcon 
            //   unit='%' 
            //   helptext={helptext.compression}
            //   title='Compression'
            //   data={dataAnalysis.compression}
            //   name='compression'
            //   onBarClick={handleValue}
            // />,
          }}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant='standard'
          inputProps={{
            style: {
              color: 'white',
              textAlign: 'left'
            }, 
            min:80, 
            max:120,
            step:0.5
          }}
        />
      </Grid>
      

      <Grid container direction='column' justifyContent ='flex-start' alignItems='center'>
        <Grid item xs={12} className={style.subcategory}>Individual Setting</Grid>
      </Grid>
      <Grid container spacing={1} alignItems='center' justifyContent="center">
        <TextField
          id="filled-number"
          name='idxPoint'
          label="Point No."
          type="number"
          defaultValue={baseshape.idxPoint}
          fullWidth
          onChange={handleValue}
          onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
          InputLabelProps={{
            style: { color: '#fff' },
            shrink: true,
          }}
          variant="standard"
          inputProps={{ 
            style: {
              color: "white",
              textAlign: "left"
            }, 
            min:0,
            max:7,
            step:1
          }}
        />
      </Grid>
      {/*
      <button className={style.buttonShowHide} onClick={() => setShowAdvance(prev => !prev)}>SHOW/HIDE Advance settings</button>
        */}
      <div>
        <Grid container spacing={1} alignItems='center' justifyContent="center">
          {(baseshape.idxPoint === 0) &&
          <TextField
            id='filled-number'
            name='filletAdductorLongus'
            label='Fillet adductor longus'
            type='number'
            defaultValue={baseshape.filletAdductorLongus}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.filletAdductorLongus; s.explanationImg = './static/ak/img/filletAdductorLongus.png'})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
            //   endAdornment: 
            //   <AddIcon 
            //     unit='mm' 
            //     helptext={helptext.filletAdductorLongus}
            //     title='Fillet adductor longus'
            //     imgSrc='./static/ak/img/filletAdductorLongus.png'
            //   />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:5, 
              max:50,
              step:1
            }}
          />
          }

          {/*
          {(baseshape.idxPoint === 1) &&
          <TextField
            id='filled-number'
            name='filletScalpa'
            label='Fillet scalpa'
            type='number'
            defaultValue={baseshape.filletScalpa}
            fullWidth
            onBlur={handleValue}
            InputProps={{
              endAdornment: <AddIcon unit='mm' helptext='Fillet of Fillet Scalpa'/>,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:5,
              max:200,
              step:1
            }}
          />
          }
          */}
          
          {(baseshape.idxPoint === 1) &&
          <TextField
            id='filled-number'
            name='point1X'
            label='Point1 ML'
            type='number'
            defaultValue={baseshape.point1X}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.point1X; s.explanationImg = './static/ak/img/point1X.png'})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm' 
              //   helptext={helptext.point1X}
              //   title='Point1 ML'
              //   imgSrc='./static/ak/img/point1X.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:-50,
              max:50,
              step:1,
            }}
          />
          }

          {(baseshape.idxPoint === 1) &&
          <TextField
            id='filled-number'
            name='point1Z'
            label='Point1 AP'
            type='number'
            defaultValue={baseshape.point1Z}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.point1Z; s.explanationImg = './static/ak/img/point1X.png'})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm' 
              //   helptext={helptext.point1Z}
              //   title='Point1 Z'
              //   imgSrc='./static/ak/img/point1X.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:-50,
              max:50,
              step:1
            }}
          />
          }

          {(baseshape.idxPoint === 2) &&
          <TextField
            id='filled-number'
            key={'rectusFemorisOverhang' + baseshape.rectusFemorisOverhang}
            name='rectusFemorisOverhang'
            label='Rectus femoris overhang'
            type='number'
            defaultValue={baseshape.rectusFemorisOverhang}
          
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.rectusFemorisOverhang; s.explanationImg = './static/ak/img/rectusFemorisOverhang.png'})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm' 
              //   helptext={helptext.rectusFemorisOverhang}
              //   title='Rectus femoris overhang'
              //   imgSrc='./static/ak/img/rectusFemorisOverhang.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:0, 
              max:500,
              step:1
            }}
          />
          }

          {(baseshape.idxPoint === 3) &&
          <TextField
            id='filled-number'
            name='point3X'
            label='Point3 ML'
            type='number'
            defaultValue={baseshape.point3X}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.point3X; s.explanationImg = './static/ak/img/point3X.png'})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm' 
              //   helptext={helptext.point3X}
              //   title='Point3 ML'
              //   imgSrc='./static/ak/img/point3X.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:-50,
              max:50,
              step:1,
            }}
          />
          }

          {(baseshape.idxPoint === 3) &&
          <TextField
            id='filled-number'
            name='point3Z'
            label='Point3 AP'
            type='number'
            defaultValue={baseshape.point3Z}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.point3Z; s.explanationImg = './static/ak/img/point3X.png'})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm'
              //   helptext={helptext.point3Z}
              //   title='Point3 AP'
              //   imgSrc='./static/ak/img/point3X.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:-50,
              max:50,
              step:1
            }}
          />
          }

          {(baseshape.idxPoint === 4) &&
          <TextField
            id='filled-number'
            name='point4X'
            label='Point4 ML'
            type='number'
            defaultValue={baseshape.point4X}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.point4X; s.explanationImg = './static/ak/img/point4X.png'})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm' 
              //   helptext={helptext.point4X}
              //   title='Point4 ML'
              //   imgSrc='./static/ak/img/point4X.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:-50,
              max:50,
              step:1,
            }}
          />
          }

          {(baseshape.idxPoint === 4) &&
          <TextField
            id='filled-number'
            name='point4Z'
            label='Point4 AP'
            type='number'
            defaultValue={baseshape.point4Z}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.point4Z; s.explanationImg = './static/ak/img/point4X.png'})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm' 
              //   helptext={helptext.point4Z}
              //   title='Point4 AP'
              //   imgSrc='./static/ak/img/point4X.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:-50,
              max:50,
              step:1
            }}
          />
          }

          {(baseshape.idxPoint === 5) &&
          <TextField
            id='filled-number'
            name='point5X'
            label='Point5 ML'
            type='number'
            defaultValue={baseshape.point5X}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.point5X; s.explanationImg = './static/ak/img/point5X.png'})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm' 
              //   helptext={helptext.point5X}
              //   title='Point5 ML'
              //   imgSrc='./static/ak/img/point5X.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:-50,
              max:50,
              step:1
            }}
          />
          }

          {(baseshape.idxPoint === 5) &&
          <TextField
            id='filled-number'
            name='point5Z'
            label='Point5 AP'
            type='number'
            defaultValue={baseshape.point5Z}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.point5Z; s.explanationImg = './static/ak/img/point5X.png'})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm' 
              //   helptext={helptext.point5Z}
              //   title='Point5 AP'
              //   imgSrc='./static/ak/img/point5X.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:-50,
              max:50,
              step:1
            }}
          />
          }


          {(baseshape.idxPoint === 6) &&
          <TextField
            id='filled-number'
            key={'filletSideWall' + baseshape.filletSideWall}
            name='filletSideWall'
            label='Fillet side wall'
            type='number'
            defaultValue={baseshape.filletSideWall}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.filletSideWall; s.explanationImg = './static/ak/img/filletSideWall.png'})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm' 
              //   helptext={helptext.filletSideWall}
              //   title='Fillet side wall'
              //   imgSrc='./static/ak/img/filletSideWall.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:5,
              max:100,
              step:1
            }}
          />
          }

          {(baseshape.idxPoint === 6) &&
          <TextField
            id='filled-number'
            name='posteriorWallAngle'
            label='Posterior Wall Angle'
            type='number'
            defaultValue={baseshape.posteriorWallAngle}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.posteriorWallAngle; s.explanationImg = './static/ak/img/posteriorWallAngle.png'})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">°</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='°' 
              //   helptext={helptext.posteriorWallAngle}
              //   title='Posterior Wall Angle'
              //   imgSrc='./static/ak/img/posteriorWallAngle.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:0, 
              max:180,
              step:1
            }}
          />
          }

          {(baseshape.idxPoint === 7) &&
          <TextField
            id='filled-number'
            name='filletIschialTuberosity'
            label='Fillet ischial tuberosity'
            type='number'
            defaultValue={baseshape.filletIschialTuberosity}
            fullWidth
            onBlur={handleValue}
            onKeyDown={e => {if (e.key === 'Enter') handleValue(e);}}
            onMouseOver={() => setControl(s => {s.explanationText = helptext.filletIschialTuberosity; s.explanationImg = './static/ak/img/filletIschialTuberosity.png'})}
            onMouseOut={() => setControl(s => {s.explanationText = ''; s.explanationImg = ''})}
            InputProps={{
              endAdornment: <InputAdornment position="start">mm</InputAdornment>,
              // endAdornment: 
              // <AddIcon 
              //   unit='mm' 
              //   helptext={helptext.filletIschialTuberosity}
              //   title='Fillet ischial tuberosity'
              //   imgSrc='./static/ak/img/filletIschialTuberosity.png'
              // />,
            }}
            InputLabelProps={{
              style: { color: '#fff' },
              shrink: true,
            }}
            variant='standard'
            inputProps={{
              style: {
                color: 'white',
                textAlign: 'left'
              }, 
              min:5, 
              max:50,
              step:1
            }}
          />
          }
        </Grid>
      </div>
    </div>
  );
}
export default FormBaseShape;